import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";
import IconButton from "components/IconButton";
import Tooltip from "components/Tooltip/Tooltip";
import { getDocumentationUrl } from "containers/Documentation/documentationService";
import { PropsWithChildren } from "react";
import "./Tooltip.scss";

interface DocsInfoTooltipProps {
    title?: string;
    text?: string;
    urlPath?: string;
    placement?: "right" | "bottom";
}

export const DocsGenericTooltip = ({
    title,
    text,
    urlPath,
    placement,
    children,
}: PropsWithChildren<DocsInfoTooltipProps>) => {
    const handleClick = (e) => e.stopPropagation();

    const Docs = ({ title, text, urlPath }: DocsInfoTooltipProps) => (
        <div className="docsInfoTooltip">
            {title && <p className="title">{title}</p>}
            {text && <p>{text}</p>}
            {urlPath && (
                <Button
                    label="Documentation"
                    href={getDocumentationUrl(urlPath)}
                    onClick={handleClick}
                    variation="clear"
                    external={true}
                    target="_blank"
                />
            )}
        </div>
    );

    return (
        <Tooltip
            placement={placement}
            overlayClassName={"light"}
            overlayStyle={{ zIndex: 20000 }}
            containInViewport={true}
            overlay={() => <Docs title={title} text={text} urlPath={urlPath} />}
        >
            {children}
        </Tooltip>
    );
};

export const DocsInfoTooltip = ({ title, text, urlPath }: DocsInfoTooltipProps) => {
    return (
        <DocsGenericTooltip title={title} text={text} urlPath={urlPath} placement={"right"}>
            <IconButton
                icon={IconCollection.helpCircleOutline}
                className="input__info-icon"
                onClick={() =>
                    urlPath &&
                    window.open(getDocumentationUrl(urlPath), "_blank", "noopener,noreferrer")
                }
            />
        </DocsGenericTooltip>
    );
};
